import * as React from 'react'
import { Radio, RadioGroup } from 'react-radio-group'

import {
  IBooleanOption,
  IRadioSelectorProps
} from '../../../../../typings/searchResults'

import * as styles from './radioSelector.module.css'

interface IState {
  selectedValue: string
}

class RadioSelector extends React.Component<IRadioSelectorProps, IState> {
  public static defaultProps = { options: [] }

  constructor(props: IRadioSelectorProps) {
    super(props)
    const { selectedValue = '' } = props
    this.state = { selectedValue }
  }

  public componentWillReceiveProps(nextProps: IRadioSelectorProps) {
    this.setState({
      selectedValue: nextProps.selectedValue || ''
    })
  }

  public render() {
    const { radioName, options } = this.props

    return (
      <RadioGroup
        name={radioName}
        className={styles.optionsWrapper}
        selectedValue={this.state.selectedValue}
        onChange={this.props.onChange}
      >
        {this.renderOptions(options)}
      </RadioGroup>
    )
  }

  private renderOptions(options: IBooleanOption[]) {
    return options.map(option => {
      return (
        <div key={option.value} className={styles.optionWrapper}>
          <label>
            <Radio value={option.value} className={styles.radioInput} />
            <span className={styles.radioLabel}>{option.label}</span>
          </label>
          <span className={styles.count}>{option.count}</span>
        </div>
      )
    })
  }
}

export default RadioSelector
